<template>
  <div class="template">
    <section class="py-24">
      <div class="container mx-auto px-6">
        <div class="text-center mb-16">
          <h2 class="text-3xl font-bold text-slate-900 dark:text-white mb-4">
            APPLICATIONS
          </h2>
          <div class="w-16 h-1 bg-primary mx-auto"></div>
        </div>

        <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div
            v-for="(item, index) in images"
            :key="'app-' + index"
            class="group"
          >
            <div
              class="aspect-square bg-slate-50 dark:bg-slate-800 rounded-2xl p-6 mb-4 flex items-center justify-center overflow-hidden"
            >
              <img
                :alt="item.msg"
                class="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                :src="item.img"
              />
            </div>
            <h3
              class="font-medium text-center text-slate-800 dark:text-slate-200 line-clamp-2"
            >
              {{ item.msg }}
            </h3>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Applications',
  components: {},
  data() {
    return {
      images: [
        {
          img: require('@/assets/app/Baby Products.jpg'),
          msg: 'Baby Products'
        },
        {
          img: require('@/assets/app/Cable Accessories.jpg'),
          msg: 'Cable Accessories'
        },
        {
          img: require('@/assets/app/Composite Insulators.jpg'),
          msg: 'Composite Insulators'
        },
        {
          img: require('@/assets/app/Daily Life.jpg'),
          msg: 'Daily Life'
        },
        {
          img: require('@/assets/app/Electronic Wire.jpg'),
          msg: 'Electronic Wire'
        },
        {
          img: require('@/assets/app/Home Appliance.jpg'),
          msg: 'Home Appliance'
        },
        {
          img: require('@/assets/app/Medical Care.jpg'),
          msg: 'Medical Care'
        },
        {
          img: require('@/assets/app/Rolling Printing.jpg'),
          msg: 'Rolling Printing'
        }
      ]
    }
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/index/Applications.vue